import { render, staticRenderFns } from "./EventCategories.vue?vue&type=template&id=dda5df46&scoped=true&"
import script from "./EventCategories.vue?vue&type=script&lang=js&"
export * from "./EventCategories.vue?vue&type=script&lang=js&"
import style0 from "./EventCategories.vue?vue&type=style&index=0&id=dda5df46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda5df46",
  null
  
)

export default component.exports